<template>
  <v-row>
    <v-col cols="12">
    <v-col
      v-if="downloading"
      class="subtitle-1 text-center"
      cols="12"
    > Cargando por favor espere...
    </v-col>
    <v-progress-linear
      indeterminate
      :background-color="backgroundLoadingColor"
      :color="loadingColor"
      height="10"
      v-if="downloading"
    ></v-progress-linear>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        :class="`elevation-1 ${navbarColor}`"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <slot name="back" />
            <v-toolbar-title v-html="title" />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details
            />
            <slot name="button">
              <v-btn
                v-if="can('crear_empresa')"
                :color="themeColor"
                dark
                class="mb-2"
                @click="newItem()"
              >
                Nuevo Registro
              </v-btn>
            </slot>
          </v-toolbar>
        </template>
        <template v-slot:item.type="{ item }" v-if="user.role === 4 || user.role === 5">
          <v-switch
            :color="themeColor"
            :input-value="item.type === 1"
            :loading="toggleStatusFEL"
            :disabled="true"
            @click.prevent="openModalStatusFEL(item)"
          />
        </template>
        <template v-slot:item.type="{ item }" v-else>
          <v-switch
            :color="themeColor"
            :input-value="item.type === 1"
            :loading="toggleStatusFEL"
            @click.prevent="openModalStatusFEL(item)"
          />
        </template>
        <template v-slot:item.receptor_id="{ item }">
          <v-switch
            :color="themeColor"
            :input-value="item.receptor_id != null && item.receptor_id > 0"
            :loading="toggleStatusReception"
            @click.prevent="openModalStatusReception(item)"
          />
        </template>
        <template v-slot:item.payroll="{ item }" v-if="user.role === 4 || user.role === 5">
          <v-switch
            :color="themeColor"
            :input-value="item.payroll != null && item.payroll != 0"
            :loading="toggleStatusPayroll"
            :disabled="true"
            @click.prevent="openModalStatusPayroll(item)"
          />
        </template>
        <template v-slot:item.payroll="{ item }" v-else>
          <v-switch
            :color="themeColor"
            :input-value="item.payroll != null && item.payroll != 0"
            :loading="toggleStatusPayroll"
            @click.prevent="openModalStatusPayroll(item)"
          />
        </template>
        <template v-slot:item.active="{ item }">
          <v-switch
            :color="themeColor"
            v-model="item.active"
            :loading="toggleStatus"
            @click.prevent="openModalStatus(item)"
          />
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                dark
                @click="profile(item)"
                v-on="on"
              >
                mdi-account-search
              </v-icon>
            </template>
            <span>Perfil</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="item.dealer_id !== null"
                :color="themeColor"
                dark
                @click.prevent="openModalDealer(item)"
                v-on="on"
              >
                mdi-truck
              </v-icon>
            </template>
            <span>Distribuidor</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label><br>
          <v-btn
            :color="themeColor"
            dark
            @click="reset"
          >
            Limpiar búsqueda
          </v-btn>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialogStatus"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres cambiar el estado de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatus = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="toggleActive()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusFEL"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de asociar este registro a Imprenta Digital?
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            No podra deshacer esta acción.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusFEL = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusFEL"
              @click.prevent="toggleActiveFEL()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusReception"
        max-width="800"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de activar este registro para Recepción?
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            No podra deshacer esta acción.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusReception = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusReception"
              @click.prevent="toggleActiveReception()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusDealer"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">
            Distribuidor
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            {{this.razonSocial}}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusDealer = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusPayroll"
        max-width="700"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de activar este registro para Nómina?
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            No podra deshacer esta acción.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusPayroll = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusPayroll"
              @click.prevent="toggleActivePayroll()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex';
  import * as _ from 'underscore';
  import Form from 'vform';

  export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('enterprises') };
    },
    props: {
      action: { default: '' },
      message: { default: '' },
      apiURL: {},
      title: { default: 'Empresas' },
    },
    data: () => ({
      downloading: false,
      loading: false,
      loadingsave: false,
      dialogShow: false,
      dialogIntegracion: false,
      dialogStatus: false,
      dialogStatusFEL: false,
      dialogStatusReception: false,
      dialogStatusDealer: false,
      dialogStatusPayroll: false,
      editedIndex: -1,
      options: {},
      search: '',
      items: [],
      totalItems: 0,
      footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
      toggleShow: false,
      toggleStatus: false,
      toggleStatusFEL: false,
      toggleStatusReception: false,
      toggleStatusPayroll: false,
      itemsCorregimiento: [],
      name: '',
      razonSocial: '',
      form: new Form({
      }),
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        minLengthInt: (v) => v.length > 7 || 'El campo debe tener al menos 8 caracteres.',
        emailRules: (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
      },
      headers: [
        {
          text: 'Tipo Documento',
          value: 'typeDocument',
          align: 'left',
          sortable: true,
        },
        {
          text: 'RIF',
          value: 'rif',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Razón Social',
          value: 'socialReason',
          align: 'left',
          sortable: true,
        },
       /*  {
          text: 'Vendedor',
          value: 'seller',
          align: 'left',
          sortable: true,
        }, */
        {
          text: 'ID',
          value: 'type',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Nómina',
          value: 'payroll',
          align: 'left',
          sortable: true,
        },
        // {
        //   text: 'Recepción',
        //   value: 'receptor_id',
        //   align: 'left',
        //   sortable: true,
        // },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
    }),
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
        },
        deep: true,
      },
      search: {
        handler() {
          this.options.page = 1;
          this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
        },
        deep: true,
      },
    },
    mounted() {
      if (this.user.role === 4 || this.user.role === 5) {
        if (!this.can('cambiar_estado')) {
          this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
        }
        if (!this.can('activar_nomina')) {
          this.headers.splice(this.headers.findIndex(({ text }) => text === 'Nómina'), 1);
        }
      } else {
        if (!this.can('activar_fel')) {
          this.headers.splice(this.headers.findIndex(({ text }) => text === 'ID'), 1);
        }
        if (!this.can('activar_nomina') && !this.can('activar_fel')) {
          this.headers.splice(this.headers.findIndex(({ text }) => text === 'Nómina'), 1);
        }
        if (!this.can('cambiar_estado')) {
          this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        taxpayer_id: 'taxpayer/id',
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        themeColor: 'theme/themeColor',
        navbarColor: 'theme/navbarColor',
      }),
    },
    methods: {
      debounceInput: _.debounce(function d(e) {
        this.search = e;
      }, 500),

      getDataFromApi() {
        this.loading = true;
        this.downloading = true;
        return new Promise(async (resolve) => {
          const {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
          } = this.options;
          const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
              const data = response.data.items;
              const { total } = response.data;
              return ({ data, total } || []);
          });
          const items = response.data;
          const { total } = response;

          setTimeout(() => {
            this.loading = false;
            this.downloading = false;
            resolve({
              items,
              total,
            });
          }, 1000);
        });
      },
      getItems(page, itemsPerPage, sortBy, sortDesc) {
        const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}&search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}`;
        const promise = window.axios.get(url).then();
        return promise;
      },
      newItem() {
        this.$router.push({ name: 'enterprise.add' });
      },
      profile(item) {
        this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}` });
      },
      openModalDealer(item) {
        this.dialogStatusDealer = true;
        this.item = item;
        if (this.item.dealer_id !== null) {
            const url = `/api/catalogs/dealers/${this.item.dealer_id}`;
            window.axios.get(url)
            .then((response) => {
              this.razonSocial = response.data.razonSocial;
            });
        }
      },
      reset() {
        this.search = '';
      },
      openModalStatus(item) {
          this.dialogStatus = true;
          this.item = item;
      },
      toggleActive() {
        this.toggleStatus = true;
        const url = `${this.apiURL}/${this.item.id}/toggle`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatus = false;
            this.action = 'toggleStatus';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatus = false;
            this.item.active = !this.item.active;
          });
      },
      openModalStatusFEL(item) {
        if (item.type === null) {
          this.dialogStatusFEL = true;
          this.item = item;
        }
      },
      toggleActiveFEL() {
        this.toggleStatusFEL = true;
        const url = `${this.apiURL}/${this.item.id}/fel`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatusFEL = false;
            this.action = 'toggleStatusFEL';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusFEL = false;
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          });
      },
      openModalStatusReception(item) {
        if (!item.receptor_id) {
          this.dialogStatusReception = true;
          this.item = item;
        }
      },
      toggleActiveReception() {
        this.toggleStatusReception = true;
        const url = `${this.apiURL}/${this.item.id}/receptor`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatusReception = false;
            this.action = 'toggleStatusReception';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusReception = false;
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          });
      },
      openModalStatusPayroll(item) {
        if (item.payroll === null || item.payroll === 0) {
          this.dialogStatusPayroll = true;
          this.item = item;
        }
      },
      toggleActivePayroll() {
        this.toggleStatusPayroll = true;
        const url = `${this.apiURL}/${this.item.id}/payroll`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatusPayroll = false;
            this.action = 'toggleStatusPayroll';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusPayroll = false;
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          });
      },
     /*  felDisable() {
        if (this.user.role === 4 || this.user.role === 5) {
          this.disabled = true;
        }
      }, */
    },
  };

</script>
